module.exports = __webpack_public_path__ + "static/img/avatar.a8c65906.png";